import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-about-footer',
  templateUrl: './about-footer.component.html',
  styleUrls: ['./about-footer.component.less']
})
export class AboutFooterComponent implements OnInit {

  year: string;

  constructor(private router: Router) {

  }

  ngOnInit() {
    this.year = (new Date()).getFullYear().toString();
  }
  canceltoggleEmp() {
    localStorage.setItem("tab_value", "0");
    this.router.navigate(['/service']);
  }
  canceltoggleEmp1() {
    localStorage.setItem("tab_value", "4");
    this.router.navigate(['/service']);
  }

}
